import React from 'react'
import { DropDownList,ComboBox } from "@progress/kendo-react-dropdowns";
import { Error } from '@progress/kendo-react-labels';

export default function UiDropDownList(props) {

  const {
    validationMessage,
    label,
    data,
    name,
    visited,
    placeholder,
    value,
    ...others
  } = props;

    return (
        
                    <>
                    <label className='sba-telerik-label'>{label}</label>
                    <ComboBox
                      data={data}  
                      textField="label"
                      dataItemKey="value"                                                                            
                      name={name}   
                      value={value}
                      {...others}                                                             
                      placeholder={placeholder}
                                    
                    />
                       {visited && validationMessage && <Error>{validationMessage}</Error>}                  
                    </>
               
       
    )
}



// import React from 'react';
// import { DropDownList } from '@progress/kendo-react-dropdowns';

// const UiDropDownList = ({ data, value, handleChange, label, labelClassName, validator, visited, validationMessage }) => {

//   const onChangeHandler = (e) => {
//     const selectedValue = e.value;
//     if (handleChange) {
//       handleChange(selectedValue);
//     }
//   };

//   return (
//     <div>
//       {label && <label className={labelClassName}>{label}</label>}
//       <DropDownList
//         data={data}
//         textField="label"
//         dataItemKey="value"
//         value={value}
//         onChange={onChangeHandler}
//       />
//           {visited && validationMessage && <div style={{ color: 'red', fontSize: '12px' }}>{validationMessage}</div>}    
//     </div>
//   );
// };

// export default UiDropDownList;




// import React from 'react'
// import { DropDownList,ComboBox } from "@progress/kendo-react-dropdowns";
// import { Form, Field } from 'react-final-form'

// export default function UiDropDownList(props) {
//   const { label, name, placeholder, data  } = props;

//     return (
//         <Field
// 			    name={name}
// 			    render={({ input, meta ,...rest}) => {
           
// 				    return (
//                     <>
//                     <label className='sba-telerik-label'>{label}</label>
//                     <ComboBox
//                       data={data}  
//                       textField="label"
//                       dataItemKey="value"                                                                            
//                       name={name}                    
//                       {...input}
//                       {...rest}                                 
//                       placeholder={placeholder}
                                    
//                     />
//                       {meta.error && <span className="k-required">{meta.error}</span>}
                        
//                     </>
//                 )}}/>
       
//     )
// }


